import gsap from "gsap"
import ScrollTrigger from 'gsap/ScrollTrigger'
import CustomEase from 'gsap/CustomEase'

gsap.registerPlugin(ScrollTrigger, CustomEase)

function initPackagesTabSwitching() {
    const packagesSection = document.querySelector('.packages')
    
    if (!packagesSection) return
    
    const tabs = packagesSection.querySelectorAll('.packages__tab')
    const tables = packagesSection.querySelectorAll('.packages__table')
    
    if (!tabs.length || !tables.length) return
    
    let isAnimating = false
    const customEase = CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
    
    tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
            e.preventDefault()
            
            if (isAnimating) return
            
            const targetIndex = parseInt(tab.getAttribute('data-table-index'))
            const currentActiveTab = packagesSection.querySelector('.packages__tab.active')
            const currentActiveTable = packagesSection.querySelector('.packages__table.active')
            const targetTable = packagesSection.querySelector(`.packages__table[data-table-index="${targetIndex}"]`)
            
            if (!targetTable || tab.classList.contains('active')) return
            
            isAnimating = true
        
            if (currentActiveTab) {
                currentActiveTab.classList.remove('active')
            }
            
            tab.classList.add('active')
            
            gsap.to(currentActiveTable, {
                autoAlpha: 0,
                duration: 0.4,
                ease: customEase,
                onComplete: () => {
                    currentActiveTable.classList.remove('active')
                    
                    gsap.set(targetTable, { autoAlpha: 0, y: 20 })
                    targetTable.classList.add('active')
                    
                    gsap.to(targetTable, {
                        autoAlpha: 1,
                        y: 0,
                        duration: 0.5,
                        ease: customEase,
                        onComplete: () => {
                            isAnimating = false
                        }
                    })
                }
            })
        })
    })
}

function initPackagesSectionAnimation() {
    const packagesSection = document.querySelector('.packages')
    
    if (!packagesSection) return
    
    const customEase = CustomEase.create("out", "0.125, 0.425, 0.270, 1.000")
    
    const intro = packagesSection.querySelector('.packages__header__right')
    
    const contentImage = packagesSection.querySelector('.packages__content__left img')
    const tabs = packagesSection.querySelector('.packages__tabs')
    const activeTable = packagesSection.querySelector('.packages__table.active')
    const contentText = packagesSection.querySelector('.packages__content__right__content > div:not(:has(table))')
    const contentButton = packagesSection.querySelector('.packages__content__right__content .button')
    
    if (intro) {
        gsap.set(intro, { autoAlpha: 0, y: 50 })
    }
    
    if (contentImage) {
        gsap.set(contentImage, { autoAlpha: 0, scale: 1.2 })
    }
    
    if (tabs) {
        gsap.set(tabs, { autoAlpha: 0, y: 50 })
    }
    
    if (activeTable) {
        gsap.set(activeTable, { autoAlpha: 0, y: 60 })
    }
    
    if (contentText) {
        gsap.set(contentText, { autoAlpha: 0, y: 40 })
    }
    
    if (contentButton) {
        gsap.set(contentButton, { autoAlpha: 0, y: 70 })
    }
    
    if (intro) {
        gsap.to(intro, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: customEase,
            scrollTrigger: {
                trigger: '.packages__header__right',
                start: 'clamp(top 85%)',
                once: true
            }
        })
    }
    
    if (contentImage) {
        gsap.to(contentImage, {
            autoAlpha: 1,
            scale: 1,
            duration: 1,
            ease: customEase,
            scrollTrigger: {
                trigger: '.packages__content',
                start: 'clamp(top 100%)',
                once: true
            }
        })
    }
    
    if (tabs) {
        gsap.to(tabs, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: customEase,
            scrollTrigger: {
                trigger: tabs,
                start: 'clamp(top 90%)',
                once: true
            }
        })
    }
    
    if (activeTable) {
        gsap.to(activeTable, {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            ease: customEase,
            scrollTrigger: {
                trigger: activeTable,
                start: 'clamp(top 90%)',
                once: true
            }
        })
    }
    
    if (contentText) {
        gsap.to(contentText, {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: customEase,
            scrollTrigger: {
                trigger: contentText,
                start: 'clamp(top 90%)',
                once: true
            }
        })
    }
    
    if (contentButton) {
        gsap.to(contentButton, {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: customEase,
            scrollTrigger: {
                trigger: contentButton,
                start: 'clamp(top 90%)',
                once: true
            }
        })
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initPackagesSectionAnimation()
        initPackagesTabSwitching()
    })
} else {
    initPackagesSectionAnimation()
    initPackagesTabSwitching()
}